import { DateWrapper } from 'kuaidong-lib'
import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum, HomeworkStatsType } from 'kuaidong-model'

import homeworkMenuIcon from '@/assets/images/icon_menu_homework@2x.png'
import homeworkMenuIconActive from '@/assets/images/icon_menu_homework_active@2x.png'

import {
  routes as templateRoutes,
  navigateToHomeworkTemplateList,
  navigateToHomeworkTemplateEdit,
  navigateToHomeworkTemplateDetails,
} from './RHomeworkTemplate'

import {
  routes,
  springSemester2022Routes,
  navigateToVacationHomeworkPlanEdit,
  redirectToVacationHomeworkPlanEdit,
  navigateToVacationHomeworkPlanDetails,
  redirectToVacationHomeworkPlanDetails,
  navigateToVacationHomeworkPlanEditChooseTemplate,
} from './RVacationHomework'

import {
  Summer2022Routes,
  navigateToSummerVacation2022List,
  navigateToSummerVacation2022Edit,
  navigateToSummerVacation2022Landing,
  redirectToSummerVacation2022Landing,
} from './RSummer2022'

const Layout = () => import('../views/Layout.vue')
const Check = () => import('../views/HomeworkCheck.vue')
const Landing = () => import('../views/homework/Landing.vue')
const PlanEdit = () => import('../views/HomeworkPlanEdit.vue')
const PlanList = () => import('../views/HomeworkPlanList.vue')
const PlanDetails = () => import('../views/HomeworkPlanDetails.vue')
const PlanEditChooseTemplate = () => import('../views/HomeworkPlanEditChooseTemplate.vue')
const PlanDetailsForLongTerm = () => import('../views/HomeworkPlanDetailsLongTerm.vue')
const Stats = () => import('../views/HomeworkStats.vue')
const StatsDetailsGrade = () => import('../views/HomeworkStatsDetailsGrade.vue')
const StatsDetailsClazz = () => import('../views/HomeworkStatsDetailsClazz.vue')
const StatsDetailsDrill = () => import('../views/HomeworkStatsDetailsDrill.vue')
const StatsDetailsClock = () => import('../views/HomeworkStatsDetailsClock.vue')
const StatsDetailsStudent = () => import('../views/HomeworkStatsDetailsStudent.vue')

const IntelligentPlanEdit = () => import('@/views/IntelligentHomeworkPlanEdit.vue')
const IntelligentPlanDetails = () => import('@/views/IntelligentHomeworkPlanDetails.vue')

export const landingRoute: RouteConfig = {
  path: 'landing',
  name: 'homework_landing',
  component: Landing,
  meta: {
    title: '了解一下',
    showMenu: true,
  },
}

export const statsRoute: RouteConfig = {
  path: 'stats',
  name: 'homework_stats',
  component: Stats,
  meta: {
    title: '统计报表',
    showMenu: true,
  },
}

export const statsDetailsGradeRoute: RouteConfig = {
  path: 'stats-details-grade',
  name: 'homework_stats_details_grade',
  component: StatsDetailsGrade,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkStatsType.ByGrade,
  }),
  meta: {
    title: '统计报表',
  },
}

export const statsDetailsClazzRoute: RouteConfig = {
  path: 'stats-details-clazz',
  name: 'homework_stats_details_clazz',
  component: StatsDetailsClazz,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkStatsType.ByClazz,
  }),
  meta: {
    title: '统计报表',
  },
}

export const statsDetailsDrillRoute: RouteConfig = {
  path: 'stats-details-drill',
  name: 'homework_stats_details_drill',
  component: StatsDetailsDrill,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkStatsType.ByDrill,
  }),
  meta: {
    title: '统计报表',
  },
}

export const statsDetailsClockRoute: RouteConfig = {
  path: 'stats-details-clock',
  name: 'homework_stats_details_clock',
  component: StatsDetailsClock,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkStatsType.ByClock,
  }),
  meta: {
    title: '统计报表',
  },
}

export const statsDetailsStudentRoute: RouteConfig = {
  path: 'stats-details-student',
  name: 'homework_stats_details_student',
  component: StatsDetailsStudent,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkStatsType.ByStudent,
  }),
  meta: {
    title: '统计报表',
  },
}

export const planListRoute: RouteConfig = {
  path: 'plan-list',
  name: 'homework_plan_list',
  component: PlanList,
  meta: {
    title: '作业计划',
    showMenu: true,
  },
}

export const planDetailsRoute: RouteConfig = {
  path: 'plan-details',
  name: 'homework_plan_details',
  component: PlanDetails,
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: Number(route.query.clazzId),
  }),
}

export const planDetailsForLongTermRoute: RouteConfig = {
  path: 'plan-details-for-long-term',
  name: 'homework_plan_details_for_long_term',
  component: PlanDetailsForLongTerm,
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: Number(route.query.clazzId),
    id: route.query.id,
  }),
}

export const planEditRoute: RouteConfig = {
  path: 'plan-edit',
  name: 'homework_plan_edit',
  component: PlanEdit,
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
  props: (route) => ({
    ...route.query,
    ...route.params,
    cid: route.query.cid ? Number(route.query.cid) : undefined,
    cids: route.query.cids ? JSON.parse(route.query.cids as string) : undefined,

    templateId: route.query.templateId ? route.query.templateId : undefined,
  }),
}

export const checkRoute: RouteConfig = {
  path: 'check',
  name: 'homework_check',
  component: Check,
  props: (route) => ({
    ...route.query,
    ...route.params,
    initialDate: route.query.initialDate ? new DateWrapper(route.query.initialDate as string).date : new Date(),
  }),
  meta: { title: '检查作业', showMenu: true },
}

export const planEditChooseTemplateRoute: RouteConfig = {
  path: 'plan-edit-choose-template',
  name: 'homework_plan_edit_choose_template',
  component: PlanEditChooseTemplate,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: route.query.clazzId ? Number(route.query.clazzId) : undefined,
  }),
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const IntelligentPlanEditRoute: RouteConfig = {
  path: 'intelligent-plan-edit',
  name: 'intelligent_plan_edit',
  component: IntelligentPlanEdit,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: route.query.clazzId ? Number(route.query.clazzId) : undefined,
    isEdit: route.query.isEdit,
  }),
  meta: {
    title: '作业计划',
  },
}

export const IntelligentPlanDetailsRoute: RouteConfig = {
  path: 'intelligent-plan-detail',
  name: 'intelligent_plan_detail',
  component: IntelligentPlanDetails,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: route.query.clazzId ? Number(route.query.clazzId) : undefined,
  }),
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export default [
  {
    path: '/homework',
    name: 'homework',
    component: Layout,
    meta: {
      title: '体育作业',
      icon: homeworkMenuIcon,
      iconActive: homeworkMenuIconActive,
      showMenu: true,
    },
    children: [
      ...Summer2022Routes,
      ...springSemester2022Routes,
      ...routes,
      planListRoute,
      planDetailsRoute,
      planDetailsForLongTermRoute,
      planEditRoute,
      checkRoute,
      planEditChooseTemplateRoute,
      IntelligentPlanEditRoute,
      IntelligentPlanDetailsRoute,
      statsRoute,
      statsDetailsGradeRoute,
      statsDetailsClazzRoute,
      statsDetailsDrillRoute,
      statsDetailsClockRoute,
      statsDetailsStudentRoute,
      ...templateRoutes,
      landingRoute,
    ],
  },
]

export { navigateToHomeworkTemplateList, navigateToHomeworkTemplateEdit, navigateToHomeworkTemplateDetails }

export {
  navigateToVacationHomeworkPlanEdit,
  redirectToVacationHomeworkPlanEdit,
  navigateToVacationHomeworkPlanDetails,
  redirectToVacationHomeworkPlanDetails,
  navigateToVacationHomeworkPlanEditChooseTemplate,
}

export {
  navigateToSummerVacation2022List,
  navigateToSummerVacation2022Edit,
  navigateToSummerVacation2022Landing,
  redirectToSummerVacation2022Landing,
}

export function navigateToHomeworkCheck(router: VueRouter, initialDate = new Date()) {
  router.push({ name: checkRoute.name, query: { initialDate: new DateWrapper(initialDate).showDateStr } })
}

export function navigateToHomeworkPlanList(router: VueRouter) {
  router.push({ name: planListRoute.name })
}

export function navigateToHomeworkPlanEdit(router: VueRouter, classId?: string) {
  router.push({ name: planEditRoute.name, query: { cid: classId } })
}

export function redirectToHomeworkPlanEdit(router: VueRouter, classId?: string, templateId?: string) {
  router.replace({ name: planEditRoute.name, query: { cid: classId, templateId } })
}

export function navigateToHomeworkStatsDetails(router: VueRouter, type: HomeworkStatsType) {
  switch (type) {
    case HomeworkStatsType.ByGrade:
      return router.push({ name: statsDetailsGradeRoute.name })
    case HomeworkStatsType.ByClazz:
      return router.push({ name: statsDetailsClazzRoute.name })
    case HomeworkStatsType.ByClock:
      return router.push({ name: statsDetailsClockRoute.name })
    case HomeworkStatsType.ByDrill:
      return router.push({ name: statsDetailsDrillRoute.name })
    case HomeworkStatsType.ByStudent:
      return router.push({ name: statsDetailsStudentRoute.name })
  }
}

export function navigateToHomeworkPlanEditChooseTemplate(router: VueRouter, clazzId?: number) {
  router.push({ name: planEditChooseTemplateRoute.name, query: { clazzId: clazzId ? String(clazzId) : null } })
}

export function redirectToIntelligentPlanEdit(router: VueRouter, isEdit = false, clazzId: number) {
  router.replace({ name: IntelligentPlanEditRoute.name, query: { isEdit: String(isEdit), clazzId: String(clazzId) } })
}

export function navigateToIntelligentPlanEdit(router: VueRouter, isEdit = false) {
  router.push({ name: IntelligentPlanEditRoute.name, query: { isEdit: String(isEdit) } })
}

export function navigateToHomeworkPlanDetails(router: VueRouter, id: string) {
  router.push({ name: planDetailsRoute.name, query: { id } })
}

export function navigateToIntelligentHomeworkPlanDetails(router: VueRouter, clazzId: number, id: string) {
  router.push({ name: IntelligentPlanDetailsRoute.name, query: { clazzId: String(clazzId), id } })
}

export function navigateToHomeworkPlanLongTermDetails(router: VueRouter, id: string) {
  router.push({
    name: planDetailsForLongTermRoute.name,
    query: {
      id,
    },
  })
}
